// src/pages/KarigarManagement/Job/components/StoneManager.jsx

import React from "react";
import { Button } from "@/components/ui-v2/button";
import { Input } from "@/components/ui-v2/input";
import { Badge } from "@/components/ui-v2/badge";
import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
} from "@/components/ui-v2/card";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui-v2/select";
import { Gem, Plus, X } from "lucide-react";
import { STONE_TYPES } from "../constants/jobConstants";

/**
 * Stone settings manager component
 */
const StoneManager = ({
  stones = [],
  onAdd,
  onUpdate,
  onRemove,
  isFromProduct = false,
  disabled = false,
}) => {
  return (
    <Card>
      <CardHeader>
        <CardTitle className="flex items-center gap-2">
          <Gem className="h-5 w-5" />
          Stone Settings
          {stones.length > 0 && isFromProduct && (
            <Badge variant="secondary" className="text-xs">
              From Product
            </Badge>
          )}
        </CardTitle>
      </CardHeader>
      <CardContent className="space-y-4">
        {stones.map((stone, index) => (
          <div
            key={index}
            className="p-4 border rounded-lg bg-muted/30 space-y-3"
          >
            <div className="flex items-center justify-between">
              <span className="text-sm font-medium">Stone #{index + 1}</span>
              <Button
                type="button"
                variant="ghost"
                size="sm"
                onClick={() => onRemove(index)}
                disabled={disabled}
              >
                <X className="h-4 w-4" />
              </Button>
            </div>
            <div className="grid grid-cols-2 gap-3">
              <Select
                value={stone.type}
                onValueChange={(v) => onUpdate(index, "type", v)}
                disabled={disabled}
              >
                <SelectTrigger>
                  <SelectValue placeholder="Stone type" />
                </SelectTrigger>
                <SelectContent>
                  {STONE_TYPES.map((s) => (
                    <SelectItem key={s.value} value={s.value}>
                      {s.label}
                    </SelectItem>
                  ))}
                </SelectContent>
              </Select>
              <Input
                type="number"
                placeholder="Qty"
                value={stone.quantity}
                onChange={(e) =>
                  onUpdate(index, "quantity", parseInt(e.target.value) || 1)
                }
                disabled={disabled}
              />
            </div>
            <Input
              placeholder="Weight/Size/Notes"
              value={stone.notes || ""}
              onChange={(e) => onUpdate(index, "notes", e.target.value)}
              disabled={disabled}
            />
          </div>
        ))}

        <Button
          type="button"
          variant="outline"
          className="w-full"
          onClick={onAdd}
          disabled={disabled}
        >
          <Plus className="h-4 w-4 mr-2" />
          Add Stone
        </Button>

        {stones.length === 0 && (
          <p className="text-sm text-muted-foreground text-center py-4">
            No stones added.
          </p>
        )}
      </CardContent>
    </Card>
  );
};

export default StoneManager;
